import ChapterTab from "./ChapterTab";

export default ChapterTab;
